'use strict';
const angular = require('angular');

export class testimonialFormComponent {
  /*@ngInject*/
  constructor(TestimonialService, dialogs, User, Auth) {
    this.Auth = Auth;
    this.TestimonialService = TestimonialService;
    this.dialogs = dialogs;

    this.user = this.Auth.getCurrentUserSync();

    this.testimonial = {
      for: -1,
      meta: {
        active: false
      }
    };

    User.query(data => {
      this.recipients = data.filter(user => user.active && user.role.includes("member")).map(user => {
        user.fullName = user.firstName + ' ' + user.lastName + ' - ' + user.companyName;
        user.group = "Members";
        return user;
      });

      this.recipients.unshift({group: "Group", fullName: "Best of the Best Network"});

      if (this.user && this.user._id) {
        this.testimonial.meta.creationUser = this.user._id;
        this.testimonial.from = this.user.firstName + ' ' + this.user.lastName;
        this.recipients = this.recipients.filter(user => user._id != this.user._id);
      }
    });
  }

  getUrl(url) {
    if (!url)
      return "";

    return (!url.startsWith("http")) ? "http://"+url : url;
  }

  checkForAdditionalReview() {
    if (!this.testimonial.for)
      return;

    let user = this.recipients.find(recipient => this.testimonial.for == recipient._id);

    if (!user)
      return;

    let googleReview = user.profile.socialMedia.find(sm => sm.type == 'Google Business');
    this.googleReviewUrl = googleReview ? this.getUrl(googleReview.link) : undefined;

    let facebook = user.profile.socialMedia.find(sm => sm.type == 'Facebook');
    this.facebookUrl = facebook ? this.getUrl(facebook.link) : undefined;
  }

  submitTestimonialForm() {
    this.TestimonialService.save(this.testimonial, () => {
      this.dialogs.notify("Your testimonial has been sent","Your testimonial has been sent for review.<br/>Thank you!");
      this.dismiss();
    });
  }
}

export default angular.module('conduuApp.testimonialForm', [])
  .component('testimonialForm', {
    template: require('./testimonial-form.component.html'),
    bindings: {
      dismiss: '&'
    },
    controller: testimonialFormComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/testimionial-form/testimonial-form.component.js